import { type Ref, ref } from "vue"

export interface MeState {
  id?: number
  name?: string
  userTitle?: string
  isBeta?: boolean
  isReferenceRequired: boolean
  permissions?: string[]
  demo: boolean
}

const meStateMap = new Map<string, Ref<any>>()

const getOrCreateState = <T>(key: string, init: () => T): Ref<T> => {
  if (typeof useState === "function") {
    return useState<T>(key, init)
  }
  if (!meStateMap.has(key)) {
    meStateMap.set(key, ref(init()))
  }
  return meStateMap.get(key)!
}

export const useMe = () => {
  const me = getOrCreateState<MeState>("me_state", () => ({
    name: undefined,
    userTitle: undefined,
    isBeta: false,
    isReferenceRequired: false,
    permissions: [],
    demo: false,
  }))

  const setId = (id: number) => {
    me.value.id = id
  }
  const setName = (name: string) => {
    me.value.name = name
  }
  const setUserTitle = (userTitle: string) => {
    me.value.userTitle = userTitle
  }
  const setPermissions = (permissions: string[]) => {
    me.value.permissions = permissions
  }
  const setIsBeta = (isBeta: boolean) => {
    me.value.isBeta = isBeta
  }
  const setIsReferenceRequired = (isReferenceRequired: boolean) => {
    me.value.isReferenceRequired = isReferenceRequired
  }
  const setDemo = (demo: boolean) => {
    me.value.demo = demo
  }

  return {
    me,
    setId,
    setName,
    setUserTitle,
    setPermissions,
    setIsBeta,
    setIsReferenceRequired,
    setDemo,
  }
}
